// extracted by mini-css-extract-plugin
export var content = "_as-3";
export var list = "_as-4";
export var settingsContent = "_as-7";
export var settingsPanel = "_as-8";
export var state = "_as-6";
export var triggerBadge = "_as-2";
export var triggerButton = "_as-1";
export var triggerShell = "_as-0";
export var unreadDot = "_as-5";